// The body is a flex item of DrawerCDS's row-flex content box, so by default it cannot be narrower than its widest
// unbreakable content: the payload's longest line, thousands of px for single-line XML. That stretched the body and the
// fields table with it. minWidth 0 keeps the body to the drawer's width, so only the payload scrolls sideways; flex 1
// fills that width when the content is narrow.
export const drawerBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  minWidth: 0,
};

export const errorListStyles = {
  margin: '4px 0 0',
  paddingLeft: '20px',
};
